import { z } from 'zod';
import { defineEndpoint } from '../define';
import { RepoFullNameSchema } from './shapes';

/** Sent by the runner's ACTIONS_RUNNER_HOOK_JOB_STARTED / _COMPLETED scripts. */
export const RunnerJobEventBodySchema = z.object({
  event: z.enum(['started', 'completed']),
  runnerName: z.string().min(1).max(255),
  repo: RepoFullNameSchema,
  runId: z.number().int().positive(),
  ts: z.string().datetime(),
});
export type RunnerJobEventBody = z.infer<typeof RunnerJobEventBodySchema>;

export const pushRunnerJobEvent = defineEndpoint({
  method: 'POST',
  path: '/v1/runner-agent/job-events',
  params: z.object({}),
  query: z.object({}),
  body: RunnerJobEventBodySchema,
  response: z.object({ data: z.object({ ok: z.boolean() }) }),
});
